'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  STRIPE: null,
  PAYPAL: null
});